export default "__VITE_ASSET__DqpAJW51__"